import React from 'react';

export const ArrowLeftCarousel = (): JSX.Element => (
  <svg width="80" height="30" viewBox="0 0 80 30">
    <rect rx="15" ry="15" width="80" height="30" fill="#2c6da4" />
    <path
      d="M45 15 L35 15 M35 15 L40 10 M35 15 L40 20"
      stroke="#fff"
      strokeWidth="2.5"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ArrowLeftCarousel;
